import React from 'react';

import { IRouter } from '@routers/interface';

export const routerLogin: IRouter = {
  path: '/login/:code',
  loader: React.lazy(() => import('./index')),
  exact: true,
  masterLayout: false,
};
